import { t } from 'i18next';

import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { CommonGrid } from '../../styledComponents/common';
import {
  EmployeeActivity,
  SmallCardContent,
  SmallCardLabel,
} from '../../styledComponents/dashboard';
import {
  DataDiv,
  DataDivHeaderWrapper,
  SmallCardContainer,
} from './cardStyles';

const EmployeeActivityCard = ({ employee_status, isLoading }) => {
  return (
    <SmallCardContainer laptopGridColumn="span 2" tabletGridColumn="span 1">
      {isLoading ? (
        <ComponentCircleLoader padding="7vh" />
      ) : (
        <>
          {employee_status &&
          employee_status.offline_employees !== undefined &&
          employee_status.online_employees !== undefined ? (
            <>
              <DataDiv>
                <DataDivHeaderWrapper>
                  <SmallCardLabel>{t('total_employees')}</SmallCardLabel>
                </DataDivHeaderWrapper>
                <SmallCardContent>
                  {' '}
                  {parseInt(employee_status.offline_employees) +
                    parseInt(employee_status.online_employees)}{' '}
                </SmallCardContent>
              </DataDiv>
              <CommonGrid
                margin="10px 0 0"
                justifyContent="stretch"
                columns="1fr 1fr"
              >
                <EmployeeActivity textAlign="center" active={true}>
                  {t('working_today')}: {employee_status.online_employees}
                </EmployeeActivity>
                <EmployeeActivity textAlign="center">
                  {t('not_working_today')}: {employee_status.offline_employees}
                </EmployeeActivity>
              </CommonGrid>
            </>
          ) : null}
        </>
      )}
    </SmallCardContainer>
  );
};

export default EmployeeActivityCard;
